function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.141,
    height: 10,
    viewBox: "0 0 10.141 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M120.563-852.958 120-856.9h1.831a2.247 2.247 0 0 1 .4-1.253 2.744 2.744 0 0 1 1.007-.887.965.965 0 0 1 .3-.683.951.951 0 0 1 .69-.275.95.95 0 0 1 .7.289.95.95 0 0 1 .289.7.95.95 0 0 1-.289.7.95.95 0 0 1-.7.289.939.939 0 0 1-.345-.063 1.158 1.158 0 0 1-.3-.176 2.076 2.076 0 0 0-.634.578 1.4 1.4 0 0 0-.268.789h7.465l-.563 3.944h-1.493l.113-.845a1.942 1.942 0 0 0-.317-1.359 1.148 1.148 0 0 0-.937-.472H123.2a1.148 1.148 0 0 0-.937.472 1.942 1.942 0 0 0-.317 1.359l.113.845zM123.2-850l-.423-4.324a.429.429 0 0 1 .106-.331.4.4 0 0 1 .317-.134h3.746a.423.423 0 0 1 .317.141.368.368 0 0 1 .106.324l-.425 4.324z",
    transform: "translate(-120 860)",
    style: {
      fill: "#196cca"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.46938b7b5063dfde9e7435e25f7d8232.svg";
export { ForwardRef as ReactComponent };